<template>
    <section aria-labelledby="searchTitle">
        <section
            v-if="otherSourcesTab"
            class="section">
            <div class="tabs flex--justifyContent-center">
                <button
                    type="button"
                    class="tabs__tab tabs__tab--large"
                    :class="{ 'tabs__tab--active' : customTab === 'statista' }"
                    data-hash="statista"
                    rel="searchForm"
                    data-gtm="searchTab__statista"
                    @keyup.enter="checkTab('statista')"
                    @click="checkTab('statista')">
                    <svg
                        class="tabs__icon"
                        viewBox="0 0 64 64"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M61.8 0H2.2C1 0 0 1 0 2.3V43h.3s9.7-.2 13.8-2.4c5.1-2.7 9-8.2 9-8.2l2.3-3.4.8-1c0-.2.4-.8.7-1.1l2.2-3.2s5.8-8.4 14-12.7C52.1 6.4 63.8 7 63.8 7h.2V2.3C64 1 63 0 61.8 0M49.6 23.4c-5 2.7-8.9 8.2-8.9 8.2L38.4 35l-.8 1.1-.7 1-2.2 3.2s-5.8 8.4-14 12.7A47.2 47.2 0 0 1 0 57.1v4.7C0 63 1 64 2.2 64h59.6c1.2 0 2.2-1 2.2-2.2V21h-.6s-9.6.3-13.8 2.4"
                            fill="#0f2741"
                            fill-rule="evenodd" />
                    </svg>
                    <span class="vertical-middle">Statista</span>
                </button>

                <button
                    v-if="dataHasGcs"
                    type="button"
                    class="tabs__tab tabs__tab--large"
                    :class="{ 'tabs__tab--active' : customTab === 'google' }"
                    data-hash="google"
                    rel="search__google"
                    data-gtm="searchTab__google"
                    @keyup.enter="checkTab('google')"
                    @click="checkTab('google')">
                    <svg
                        class="tabs__icon"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        viewBox="0 0 48 48">
                        <defs><path
                            id="tabsGoogleLogoPath"
                            d="M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" /></defs>
                        <clipPath id="tabsGoogleLogoClipPath"><use
                            xlink:href="#tabsGoogleLogoPath"
                            overflow="visible" /></clipPath>
                        <path
                            clip-path="url(#tabsGoogleLogoClipPath)"
                            fill="#FBBC05"
                            d="M0 37V11l17 13z" />
                        <path
                            clip-path="url(#tabsGoogleLogoClipPath)"
                            fill="#EA4335"
                            d="M0 11l17 13 7-6.1L48 14V0H0z" />
                        <path
                            clip-path="url(#tabsGoogleLogoClipPath)"
                            fill="#34A853"
                            d="M0 37l30-23 7.9 1L48 0v48H0z" />
                        <path
                            clip-path="url(#tabsGoogleLogoClipPath)"
                            fill="#4285F4"
                            d="M48 48L17 24l-4-3 35-10z" />
                    </svg>
                    <span class="vertical-middle">Google</span>
                </button>

                <button
                    v-if="dataHasKcs"
                    class="tabs__tab tabs__tab--large"
                    :class="{ 'tabs__tab--active' : customTab === 'kobra' }"
                    data-hash="kobra"
                    rel="search__kobra"
                    data-gtm="searchTab__kobra"
                    type="button"
                    @keyup.enter="checkTab('kobra')"
                    @click="checkTab('kobra')">
                    <svg
                        id="kobraIcon"
                        class="tabs__icon"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 32 32">
                        <g>
                            <path
                                fill="#e2001a"
                                d="M16.65,8.26l0,0c.25-.36.15-.63,0-.77L14.08,5.86a.68.68,0,0,1-.3-.56c0-.37.22-.65.72-.79a61.58,61.58,0,0,1,9.11-.66c.66,0,1.8,0,2.82,0l0,0A16,16,0,0,0,3.69,26.22c2-2.89,7-10,8.06-11.47,1.25-1.68,4.11-5.41,4.59-6l0,0Z"
                                transform="translate(0 0)" />
                            <path
                                fill="#e2001a"
                                d="M6.24,28.68A16,16,0,0,0,30.18,8.59h0A2.18,2.18,0,0,0,31,6.17,7,7,0,0,0,30,5l0,.06a2.2,2.2,0,0,1-.93,2.42c-.3.27-4.37,4.1-9.13,8.27-4.2,3.67-8.9,7.41-11.62,9.44C4.55,28,3.81,28.44,3.81,28.44a.88.88,0,0,1-.39.11.71.71,0,0,1-.57-.28h0v.12c.41.66,1.09,1.44,1.48,1.44a.88.88,0,0,0,.4-.11s.3-.16,1.52-1"
                                transform="translate(0 0)" />
                            <path
                                fill="#fff"
                                d="M16.68,8.22a.55.55,0,0,0,0-.77L14.07,5.86a.68.68,0,0,1-.3-.56c0-.37.22-.65.72-.79a61.78,61.78,0,0,1,9.11-.66c.9,0,2.68,0,3.86.07s2.31.36,2.56,1a2.18,2.18,0,0,1-.89,2.54c-.31.27-4.37,4.1-9.13,8.27-4.2,3.67-8.9,7.41-11.62,9.45C4.55,28,3.81,28.45,3.81,28.45a1.07,1.07,0,0,1-.4.1.7.7,0,0,1-.71-.7.74.74,0,0,1,.13-.41s7.54-10.86,8.91-12.69S16.4,8.62,16.4,8.62l.28-.4"
                                transform="translate(0 0)" />
                        </g>
                    </svg>
                    <span class="vertical-middle">KoBra</span>
                </button>
            </div>
        </section>
        <h1
            id="searchTitle"
            class="visually-hidden">
            {{ trans('SEARCH') }}
        </h1>
        <search-content
            v-show="customTab === 'statista'"
            :id-basic="idBasic"
            :id-standard="idStandard"
            :selected-categories-value="selectedCategoriesValue" />
        <!-- Google Search -->
        <div :key="key">
            <div
                v-show="otherSourcesTab && dataHasGcs && customTab === 'google'"
                id="search__google"
                class="tabContent">
                <section
                    id="googleCustomSearch"
                    class="section bg-light padding-horizontal-50 padding-vertical-50 padding-horizontal-s-0 padding-bottom-s-20 padding-vertical-s-30 border-bottom-gray20-1">
                    <div class="flex text-center">
                        <div
                            v-pre
                            class="width100 padding-horizontal-30 padding-horizontal-s-0">
                            <gcse:searchbox />
                        </div>
                    </div>
                </section>
                <div v-pre>
                    <gcse:searchresults>
                        <div class="center padding-vertical-15">
                            <img
                                :src="getCdnLink('img/preloaders/preloader.gif')"
                                width="20"
                                height="20"
                                class="display-inline-block" />
                        </div>
                    </gcse:searchresults>
                    <div class="hide">
                        <div
                            class="noResults"
                            data-gcse-no-results>
                            {{ trans('SEARCH_ENTER_TERM') }}
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-show="otherSourcesTab && dataHasKcs && customTab === 'kobra'"
                d="search__kobra"
                data-tabbar-content="search__kobra"
                class="tabContent">
                <section
                    id="kobraCustomSearch"
                    class="section bg-light padding-horizontal-50 padding-vertical-50 padding-horizontal-s-0 padding-bottom-s-20 padding-vertical-s-30 border-bottom-gray20-1">
                    <KobraSearchbar />
                </section>

                <div>
                    <!-- Filter -->
                    <div class="row">
                        <div class="width33 hideMobile">
                            <section class="section section__searchFilter row margin-bottom-40 padding-top-0">
                                <div class="padding-top-20">
                                    <kobra-filter
                                        @changebranchgroup="selectedKobraBranchGroup = $event"
                                        @changeinfotype="selectedKobraInfoType = $event"
                                        @changesearchtype="selectedKobraSearchType = $event" />
                                </div>
                            </section>
                            <div class="row text-center padding-right-15">
                                <div id="dc-content">
                                </div>
                            </div>
                        </div>
                        <div class="width66">
                            <div class="padding-all-20  padding-horizontal-s-0">
                                <div class="row">
                                    <h4 class="h3 font-size-s-110 bold showMobile">
                                        {{ trans('SEARCH_RESULTS') }}
                                        <span class="text-normal">{{ totalFoundSumRegion }}</span>
                                    </h4>
                                </div>
                                <!-- Results Kobra -->
                                <KobraResults />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { defineComponent } from 'vue';
    import { useGetters, useActions, useMutations } from 'composables/useVuex';

    import Translator from 'tools/trans';
    import { getCookie } from 'tools/cookies';

    import SearchContent from './searchContent';
    import { GOOGLE_ENGINE_IDS } from './googleEngineIds';
    import KobraFilter from './kobraFilter.vue';
    import KobraResults from './kobra/results.vue';
    import KobraSearchbar from './kobra/searchbar.vue';
    import { pushToDataLayer } from 'search/dataLayer';

    export default defineComponent({
        name: 'AnoSearchResults',
        components: {
            SearchContent,
            KobraFilter,
            KobraResults,
            KobraSearchbar,
        },
        props: {
            locale: { type: String, default: null },
            entities: { type: [Object, Array], default: () => [] },
            contentOwners: { type: [Object, Array], default: () => ({}) },
            preferred: { type: [Object, Array], default: () => [] },
            countries: { type: Array, default: () => undefined },
            path: { type: Object, default: () => ({}) },
            focus: { type: String, default: '' },
            alternativeKeywords: { type: Object, default: () => ({}) },
            currentPage: { type: Number, default: 0 },
            promotedContent: { type: Array, default: () => [] },
            totalFound: { type: Number, default: 0 },
            actionContent: { type: String, default: null },
            otherSourcesTab: { type: Boolean, default: false },
            allowBrowseHistory: { type: Boolean, default: false },
            dataSearchQuery: { type: String, default: null },
            dataHasGcs: { type: Boolean, default: false },
            dataHasKcs: { type: Boolean, default: false },
            dataHasGds: { type: Boolean, default: false },
            userHasGcsRight: { type: Boolean, default: false },
            kobraTestTab: { type: Boolean, default: false },
            dataSelectedSorting: { type: String, default: null },
            dataSelectedLanguage: { type: String, default: null },
            hrefBrowseHistory: { type: String, default: null },
            intervalData: { type: Array, default: () => [] },
            branchesData: { type: Array, default: () => [] },
            regionsData: { type: Array, default: () => [] },
            isoregionsData: { type: Array, default: () => [] },
            idBasic: { type: String, default: '0' },
            idStandard: { type: String, default: '0' },
            totalFoundSumRegion: { type: [Number, String], default: '0' },
            selectedCategoriesValue: { type: Object, default: () => {} },
        },
        data() {
            return {
                customTab: 'statista',
                selectedKobraBranchGroup: null,
                selectedKobraInfoType: null,
                selectedKobraSearchType: null,
                key: 0,
            };
        },
        watch: {
            loading() {
                this.key = this.key + 1;
            },
        },
        methods: {
            trans: Translator.trans,
            checkTab(selectedTab) {
                this.customTab = selectedTab;
                if (this.dataHasGcs && selectedTab === 'google') {
                    this.initGoogleCustomSearch();
                }
            },
            initGoogleCustomSearch() {
                window.__gcse = {
                    callback: gcseCallback,
                };
                function gcseCallback() {
                    const searchQuery = document.getElementById('searchResults') ? document.getElementById('searchResults').getAttribute('data-search-query') : this.query;
                    document.querySelector('input.gsc-input[name=search]').value = typeof searchQuery !== 'undefined' ? searchQuery : '';
                    const hiddenContainer = document.querySelector('.gsc-resultsbox-invisible');
                    const child = document.querySelector('[data-gcse-no-results]');
                    if (hiddenContainer !== null) {
                        insertAfter(child, hiddenContainer);
                    }
                    function insertAfter(newNode, referenceNode) {
                        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
                    }
                }
                const googleEngineId = this.getGoolgeEngineId(window.stGlobals.locale);
                const gcseScriptElement = document.createElement('script');
                gcseScriptElement.type = 'text/javascript';
                gcseScriptElement.async = true;
                gcseScriptElement.src = `https://cse.google.com/cse.js?cx=${ googleEngineId }`;
                const s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(gcseScriptElement, s);
            },
            getGoolgeEngineId(locale) {
                return GOOGLE_ENGINE_IDS[locale];
            },
        },
        mounted() {
            if (this.dataHasGcs) {
                this.initGoogleCustomSearch();
            }
        },
        setup(props) {

            // countries is an Array -> we have to convert it to array because Server sometimes delivers an Object
            const countries = Array.isArray(props.countries) ? props.countries : (() => {

                const preferred = Array.isArray(props.preferred) ? props.preferred : Object.keys(props.preferred).map((item) => {
                    return props.preferred[item];
                });

                const countries = Object.keys(props.countries).map((item) => {
                    return props.countries[item];
                });

                return [
                    ...preferred,
                    {
                        value: -2,
                        label: '-----------------',
                    },
                    ...countries,
                ];
            })();

            const getters = {
                ...useGetters('search', [
                    'query',
                    'loading',
                    'getShowSidebar',
                    'sort',
                ]),
            };

            const showSidebar = getters.getShowSidebar;
            const loading = getters.loading;
            const actions = {
                ...useActions('globalSettings', ['initValues']),
                ...useActions('search', ['setValue', 'startSearch', 'setEntities', 'setCountries', 'getHistory', 'setPath']),
            };

            const mutations = {
                ...useMutations(['initSearchQueryParameters']),
                ...useMutations('search', ['setFigures', 'setValue', 'setSort', 'setFocus', 'setIntervalData', 'setBranchesData', 'setRegionsData', 'setIsoregionsData', 'setUserPermission', 'setSelectedCategories']),
            };

            // init query parameters
            mutations.initSearchQueryParameters();

            // set search arrays
            mutations.setFigures({
                currentPage: props.currentPage,
                totalFound: props.totalFound,
            });
            actions.setEntities(props.entities);
            actions.setCountries(countries);
            actions.setPath(props.path);
            mutations.setSort(getters.sort.value);
            mutations.setIntervalData(props.intervalData);
            mutations.setBranchesData(props.branchesData);
            mutations.setRegionsData(props.regionsData);
            mutations.setIsoregionsData(props.isoregionsData);
            mutations.setUserPermission(props.userHasGcsRight);
            const focusCookie = getCookie('regionDefault');
            mutations.setFocus(props.focus !== '' ? props.focus : focusCookie);

            actions.getHistory();

            (async () => {
                // transfer query value from main to search module -> use mutations to not get the logic for searchbox
                const loc = new URL(window.location);
                const query = loc.searchParams.get('q');
                if (query) {
                    await actions.setValue({ value: query });
                }
                // get initial entries & report area
                // 0 => redirection , 1 => reload , 2 => backbutton
                const typeOfAction = performance.navigation.type;
                await actions.startSearch({ resetTags: typeOfAction === 0 });
                // push to data layer

                if (typeOfAction === 0) {
                    setTimeout(() => {
                        pushToDataLayer();
                    }, 100);
                }
            })();

            // initvalues
            actions.initValues({
                ...props,
            });

            return {
                ...getters,
                showSidebar,
                loading,
            };
        },
    });
</script>
